export const THEME_STORAGE_KEY = 'appTheme'
export const DEFAULT_THEME = 'dark'
const ALLOWED_THEMES = new Set(['dark', 'light'])

export function getInitialTheme() {
  const stored = String(localStorage.getItem(THEME_STORAGE_KEY) || '')
    .trim()
    .toLowerCase()
  if (ALLOWED_THEMES.has(stored)) {
    return stored
  }
  return DEFAULT_THEME
}

export function setStoredTheme(themeName) {
  const normalized = String(themeName || '')
    .trim()
    .toLowerCase()
  if (!ALLOWED_THEMES.has(normalized)) {
    return
  }
  localStorage.setItem(THEME_STORAGE_KEY, normalized)
}
